"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModuleTemplateType = void 0;
/* eslint-disable require-jsdoc */
const AppAvailability_1 = require("./AppAvailability");
const SubjectInfo_1 = require("./SubjectInfo");
const constants_1 = require("../constants");
const zod_1 = require("zod");
class ModuleTemplateType {
    constructor(id, title, description, appAvailability) {
        this.subjects = [];
        this.parentLevelIds = [];
        this.cardCount = 0;
        this.conceptCount = 0;
        this.studyCount = 0;
        this.id = id;
        this.title = title;
        this.description = description;
        this.appAvailability = appAvailability;
    }
    static collectionPath() {
        return constants_1.constants.COLLECTION_PATH_MODULE_TEMPLATE;
    }
}
exports.ModuleTemplateType = ModuleTemplateType;
ModuleTemplateType.jsonSchema = zod_1.z.object({
    id: zod_1.z.string().optional(),
    title: zod_1.z.string(),
    description: zod_1.z.string(),
    subjects: zod_1.z.array(SubjectInfo_1.SubjectInfoJSONSchema).default([]),
    parentLevelIds: zod_1.z.array(zod_1.z.string()).default([]),
    imageString: zod_1.z.string().optional(),
    appAvailability: AppAvailability_1.AppAvailability.jsonSchema,
    representationColor: zod_1.z.string().optional(),
    cardCount: zod_1.z.number().default(0),
    conceptCount: zod_1.z.number().default(0),
    authorId: zod_1.z.string().optional(),
    lastUpdateDate: zod_1.z.object({
        _seconds: zod_1.z.number(),
        _nanoseconds: zod_1.z.number()
    })
});
